import { BarometerNav } from "@/components/BarometerNav";
import { useState, useEffect } from "react";
import { CheckoutButton } from "@/components/CheckoutButton";

const MEETERGO_URL =
  "https://cal.meetergo.com/larissa-girenko/30-min-meeting-or-larissa-girenko?utm_source=google-ads-page&utm_medium=cta&utm_content=google-ads-betreuung";
const ANALYSE_URL = MEETERGO_URL; // Buchungs-URL für die Potenzialanalyse
const HERO_IMG =
  "https://d2xsxph8kpxj0f.cloudfront.net/310519663476281654/fDRgangGWFphFKzWtNAEav/larissa-hero_39f19908.jpeg";

/* ── Design-Tokens (exakt wie Hauptdesign) ── */
const C = {
  bordeaux: "#6d0000",
  bordeauxHover: "#8b0000",
  black: "#000000",
  darkBg: "#0a0a0a",
  sectionBg: "#111111",
  cardBg: "#1a1a1a",
  white: "#ffffff",
  offWhite: "#f0ede8",
  lightBg: "#f9f7f5",       // helle Sektion (wie Startseite)
  lightCard: "#ffffff",     // weiße Karte
  lightBorder: "#e5e0db",  // heller Border
  textDark: "#1a1a1a",     // dunkler Text auf hellem Hintergrund
  textMid: "#555555",      // mittlerer Text auf hellem Hintergrund
  muted: "#9ca3af",
  mutedDark: "#6b7280",
  border: "#2a2a2a",
  borderLight: "#333333",
};

const FONT_HEADING = "'Bebas Neue', sans-serif";
const FONT_BODY = "'DM Sans', sans-serif";

/* ── Pakete ── */
const PAKETE = [
  {
    name: "STARTER",
    preis: "397 €",
    zeitraum: "/ Monat",
    highlight: false,
    tag: null,
    // Anchoring: Starter wirkt günstig durch Vergleich mit Professional
    beschreibung: "Für Selbstständige & kleine Unternehmen mit Werbebudget bis 500 €/Monat.",
    leistungen: [
      "1 Kampagne (Such-Netzwerk)",
      "Keyword-Recherche & Anzeigentexte",
      "Conversion-Tracking Setup",
      "Monatliches Reporting",
      "Laufende Optimierung",
      "E-Mail-Support",
      "Potenzialanalyse wird angerechnet",
    ],
    cta: "Jetzt anfragen",
    savingsNote: null,
    perTagNote: null,
  },
  {
    name: "PROFESSIONAL",
    preis: "697 €",
    zeitraum: "/ Monat",
    highlight: true,
    tag: "EMPFOHLEN – BESTE WAHL",
    // Anchoring: Mittleres Paket wird durch Starter (zu wenig) und Premium (zu teuer) als "genau richtig" wahrgenommen
    beschreibung: "Für Unternehmen mit Wachstumsambitionen und Budget von 500–2.000 €/Monat.",
    leistungen: [
      "Bis zu 3 Kampagnen",
      "Such- & Display-Netzwerk",
      "Vollständiges Conversion-Tracking",
      "Wöchentliche Optimierung",
      "Monatlicher Strategie-Call",
      "WhatsApp & E-Mail-Support",
      "Wettbewerbs-Monitoring",
      "Potenzialanalyse wird angerechnet",
    ],
    cta: "Jetzt anfragen",
    savingsNote: "Nur 23,23 € / Tag – weniger als ein Mitarbeiter-Stundenlohn",
    perTagNote: "= 23 € / Tag",
  },
  {
    name: "PREMIUM",
    preis: "Ab 1.297 €",
    zeitraum: "/ Monat",
    highlight: false,
    tag: "FÜR AMBITIONIERTE",
    // Decoy-Effekt: Premium macht Professional günstiger wirken
    beschreibung: "Für Unternehmen mit komplexen Kampagnenstrukturen und hohem Budget (ab 3.000 €/Monat).",
    leistungen: [
      "Unbegrenzte Kampagnen",
      "Such, Display, Shopping & YouTube",
      "Vollständiges Tracking & Analytics",
      "Wettbewerbs-Monitoring",
      "Wöchentlicher Reporting-Call",
      "Priorisierter Support",
      "Individuelle Strategie-Workshops",
      "Potenzialanalyse wird angerechnet",
    ],
    cta: "Anfrage senden",
    savingsNote: null,
    perTagNote: null,
  },
];

const FAQ_ITEMS = [
  {
    frage: "Was kostet die Google Ads Potenzialanalyse?",
    antwort:
      "Die Potenzialanalyse kostet einmalig 297 € zzgl. MwSt. Dieser Betrag wird bei Buchung einer laufenden Betreuung innerhalb von 30 Tagen vollständig angerechnet – du zahlst also nur einmal.",
  },
  {
    frage: "Was ist die Google Ads Potenzialanalyse?",
    antwort:
      "Die Potenzialanalyse ist dein Einstieg: Ich analysiere entweder deinen bestehenden Google Ads Account (Account-Audit) oder – wenn du noch keinen hast – das Marktpotenzial für dein Business. Du erhältst einen ausführlichen schriftlichen Report mit konkreten Handlungsempfehlungen sowie einen Video-Call zur Besprechung. Der Preis wird bei Buchung einer laufenden Betreuung vollständig angerechnet.",
  },
  {
    frage: "Wie viel Werbebudget brauche ich mindestens?",
    antwort:
      "Ich empfehle ein Mindestbudget von 300–500 € pro Monat für Google Ads, damit ausreichend Daten für eine sinnvolle Optimierung gesammelt werden können. Das Werbebudget ist separat von meiner Betreuungsgebühr und wird direkt an Google gezahlt.",
  },
  {
    frage: "Wie schnell sehe ich erste Ergebnisse?",
    antwort:
      "Erste Klicks und Anfragen kommen oft schon in der ersten Woche. Für eine stabile, optimierte Performance rechne ich realistisch mit 4–8 Wochen – das ist bei Google Ads branchüblich. Ich kommuniziere transparent, was in welchem Zeitraum realistisch ist.",
  },
  {
    frage: "Übernimmst du auch bestehende Kampagnen?",
    antwort:
      "Ja. Ich starte immer mit der Potenzialanalyse (Account-Audit) und zeige dir, wo Budget verschwendet wird und welche Hebel am meisten bringen. Dann entscheiden wir gemeinsam, ob wir optimieren oder neu aufbauen.",
  },
  {
    frage: "Wie läuft die Zusammenarbeit ab?",
    antwort:
      "Wir starten mit der Potenzialanalyse. Danach erstelle ich eine Strategie und starte das Setup. Du behältst vollen Zugang zu deinem Google Ads Account – ich arbeite darin, du behältst die Kontrolle. Monatlich gibt es ein Reporting mit konkreten Zahlen.",
  },
  {
    frage: "Gibt es eine Mindestlaufzeit?",
    antwort:
      "Ich empfehle 3 Monate Mindestlaufzeit, damit Kampagnen genug Zeit haben, sich zu entwickeln und zu optimieren. Danach monatlich kündbar.",
  },
  {
    frage: "Was unterscheidet dich von einer großen Agentur?",
    antwort:
      "Bei mir hast du eine feste Ansprechpartnerin – nicht ein wechselndes Team. Ich kenne dein Business persönlich, reagiere schnell und erkläre alles in verständlicher Sprache. Keine Ticketsysteme, kein Callcenter.",
  },
];

/* ── Scarcity-Counter ── */
function SlotsCounter() {
  const [slots] = useState(2);
  const month = new Date().toLocaleDateString('de-DE', { month: 'long' });
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        backgroundColor: C.cardBg,
        border: `1px solid ${C.bordeaux}`,
        padding: "8px 18px",
        marginBottom: 28,
      }}
    >
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          backgroundColor: C.bordeaux,
          display: "inline-block",
          animation: "pulse 1.5s infinite",
          flexShrink: 0,
        }}
      />
      <span style={{ fontFamily: FONT_BODY, fontSize: 13, color: C.offWhite, letterSpacing: "0.05em" }}>
        Nur noch <strong style={{ color: "#fff" }}>{slots} freie Plätze</strong> im {month} verfügbar
      </span>
    </div>
  );
}

/* ── Verlust-Rechner (Loss Aversion) ── */
function LossCalculator() {
  const [budget, setBudget] = useState(500);
  const wastePct = 0.37; // Ø 37% Budget-Verschwendung ohne Profi-Betreuung (WordStream-Studie)
  const waste = Math.round(budget * wastePct);
  const yearWaste = waste * 12;

  return (
    <div
      style={{
        backgroundColor: C.cardBg,
        border: `1px solid ${C.bordeaux}`,
        padding: "32px 28px",
        maxWidth: 560,
        margin: "0 auto",
        width: "100%",
        boxSizing: "border-box" as const,
      }}
    >
      <p
        style={{
          fontFamily: FONT_HEADING,
          fontSize: 13,
          letterSpacing: "0.2em",
          color: C.bordeaux,
          textTransform: "uppercase",
          marginBottom: 8,
        }}
      >
        Budget-Verlust-Rechner
      </p>
      <h3
        style={{
          fontFamily: FONT_HEADING,
          fontSize: 28,
          color: C.white,
          marginBottom: 20,
          lineHeight: 1.1,
        }}
      >
        Wie viel Budget verbrennst du gerade?
      </h3>
      <div style={{ marginBottom: 20 }}>
        <label
          style={{
            fontFamily: FONT_BODY,
            fontSize: 13,
            color: C.muted,
            display: "block",
            marginBottom: 8,
            textTransform: "uppercase",
            letterSpacing: "0.1em",
          }}
        >
          Dein monatliches Google Ads Budget: <strong style={{ color: C.white }}>{budget} €</strong>
        </label>
        <input
          type="range"
          min={100}
          max={5000}
          step={50}
          value={budget}
          onChange={(e) => setBudget(Number(e.target.value))}
          style={{ width: "100%", accentColor: C.bordeaux, cursor: "pointer" }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: 11,
            color: C.mutedDark,
            marginTop: 4,
          }}
        >
          <span>100 €</span>
          <span>5.000 €</span>
        </div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 16,
          marginBottom: 20,
        }}
      >
        <div style={{ backgroundColor: C.sectionBg, border: `1px solid ${C.borderLight}`, padding: "16px 20px" }}>
          <div style={{ fontFamily: FONT_HEADING, fontSize: 36, color: C.bordeaux, lineHeight: 1 }}>
            {waste} €
          </div>
          <div style={{ fontSize: 12, color: C.muted, marginTop: 4 }}>Monatlicher Verlust</div>
        </div>
        <div style={{ backgroundColor: C.sectionBg, border: `1px solid ${C.borderLight}`, padding: "16px 20px" }}>
          <div style={{ fontFamily: FONT_HEADING, fontSize: 36, color: C.bordeaux, lineHeight: 1 }}>
            {yearWaste} €
          </div>
          <div style={{ fontSize: 12, color: C.muted, marginTop: 4 }}>Jährlicher Verlust</div>
        </div>
      </div>
      <p style={{ fontSize: 12, color: C.mutedDark, lineHeight: 1.6, marginBottom: 20 }}>
        Laut WordStream-Studie verschwenden Unternehmen ohne professionelle Betreuung Ø 37 % ihres Google Ads Budgets durch falsche Keywords, schlechte Anzeigentexte und fehlende Optimierung.
      </p>
      <CheckoutButton
        productId="google_ads_potenzialanalyse"
        label="Google Ads Potenzialcheck buchen →"
        price="297 €"
        returnPath="/google-ads"
        fullWidth
      />
      <p style={{ fontSize: 11, color: C.muted, marginTop: 8, textAlign: "center" }}>Zahlung über Stripe (SSL). Kein Abo.</p>
    </div>
  );
}

export default function GoogleAds() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [scrolled, setScrolled] = useState(false);
  const [stickyVisible, setStickyVisible] = useState(false);

  // Dynamischer Monatsname für Scarcity
  const currentMonth = new Date().toLocaleDateString('de-DE', { month: 'long' });

  useEffect(() => {
    // SEO: Seitenspezifische Meta-Tags
    const prevTitle = document.title;
    document.title = "Google Ads Betreuung | WERBEAGENTUR Larissa Girenko";
    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
      return el;
    };
    const metas = [
      setMeta("description", "Google Ads Betreuung für Selbstständige & KMU. Persönliche Betreuung durch Larissa Girenko – Strategie, Optimierung, Reporting. Jetzt Google Ads Potenzialanalyse™ buchen."),
      setMeta("robots", "index, follow"),
      setMeta("og:title", "Google Ads Betreuung | WERBEAGENTUR Larissa Girenko", true),
      setMeta("og:description", "Kein verschwendetes Budget. Keine Blackbox. Persönliche Google Ads Betreuung – von Strategie bis Auswertung. Jetzt Potenzialanalyse™ buchen.", true),
      setMeta("og:type", "website", true),
      setMeta("og:url", "https://barometer.werbeagentur.me/google-ads", true),
      setMeta("og:image", "https://d2xsxph8kpxj0f.cloudfront.net/310519663476281654/fDRgangGWFphFKzWtNAEav/larissa-hero_39f19908.jpeg", true),
      setMeta("twitter:card", "summary_large_image"),
      setMeta("twitter:title", "Google Ads Betreuung | WERBEAGENTUR Larissa Girenko"),
      setMeta("twitter:description", "Persönliche Google Ads Betreuung für KMU. Potenzialanalyse™ buchen."),
    ];
    // JSON-LD: Service + FAQPage
    const jsonLd = document.createElement("script");
    jsonLd.type = "application/ld+json";
    jsonLd.id = "google-ads-jsonld";
    jsonLd.text = JSON.stringify([
      {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Google Ads Betreuung",
        "description": "Persönliche Google Ads Betreuung für Selbstständige und KMU. Strategie, Kampagnen-Setup, laufende Optimierung und monatliches Reporting.",
        "provider": { "@type": "LocalBusiness", "name": "WERBEAGENTUR Larissa Girenko", "url": "https://werbeagentur.me" },
        "areaServed": "DE",
        "serviceType": "Google Ads Management",
        "offers": [
          { "@type": "Offer", "name": "Google Ads Potenzialanalyse™", "price": "297", "priceCurrency": "EUR", "description": "Vollständige Analyse nach 12 Faktoren + schriftlicher Report + 60-min Video-Call" },
          { "@type": "Offer", "name": "STARTER Betreuung", "price": "397", "priceCurrency": "EUR" },
          { "@type": "Offer", "name": "PROFESSIONAL Betreuung", "price": "697", "priceCurrency": "EUR" },
          { "@type": "Offer", "name": "PREMIUM Betreuung", "price": "1297", "priceCurrency": "EUR" }
        ]
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": FAQ_ITEMS.map(f => ({
          "@type": "Question",
          "name": f.frage,
          "acceptedAnswer": { "@type": "Answer", "text": f.antwort }
        }))
      }
    ]);
    document.head.appendChild(jsonLd);
    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.href = "https://barometer.werbeagentur.me/google-ads";
    // hreflang
    let hreflang = document.querySelector('link[rel="alternate"][hreflang="de"]') as HTMLLinkElement | null;
    if (!hreflang) { hreflang = document.createElement("link"); hreflang.rel = "alternate"; hreflang.setAttribute("hreflang", "de"); document.head.appendChild(hreflang); }
    hreflang.href = "https://barometer.werbeagentur.me/google-ads";
    return () => {
      document.title = prevTitle;
      metas.forEach(el => el?.parentNode?.removeChild(el));
      jsonLd.parentNode?.removeChild(jsonLd);
    };
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 80);
      setStickyVisible(window.scrollY > 600);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      style={{
        fontFamily: FONT_BODY,
        backgroundColor: C.black,
        color: C.white,
        minHeight: "100vh",
      }}
    >
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .ga-hero-animate { animation: fadeInUp 0.7s ease both; }
        .ga-hero-animate-2 { animation: fadeInUp 0.7s 0.15s ease both; }
        .ga-hero-animate-3 { animation: fadeInUp 0.7s 0.3s ease both; }
        .ga-cta-btn:hover { background-color: #8b0000 !important; }
        .ga-outline-btn:hover { border-color: #fff !important; color: #fff !important; }
        .ga-paket-card { transition: transform 0.2s ease; }
        .ga-paket-card:hover { transform: translateY(-4px); }
        /* Responsive Problem-Grid */
        .problem-grid { display: grid; grid-template-columns: 1fr; gap: 48px; }
        @media (min-width: 768px) { .problem-grid { grid-template-columns: 1fr 1fr; gap: 64px; align-items: center; } }
        /* Responsive Analyse-Card */
        .analyse-card-inner { display: flex; flex-direction: column; gap: 0; }
        .analyse-preis-box { width: 100%; box-sizing: border-box; }
        @media (min-width: 768px) {
          .analyse-card-inner { flex-direction: row; align-items: stretch; }
          .analyse-card-content { flex: 1; }
          .analyse-preis-box { width: 220px; min-width: 220px; flex-shrink: 0; }
        }
      `}</style>

      {/* Preload Hero-Bild für LCP-Optimierung */}
      <link rel="preload" as="image" href={HERO_IMG} />
      <BarometerNav />

      {/* ── Sticky-CTA Mobile (erscheint nach 600px Scroll) ── */}
      <div
        className="md:hidden"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 9000,
          transform: stickyVisible ? "translateY(0)" : "translateY(100%)",
          transition: "transform 0.3s ease",
          backgroundColor: C.bordeaux,
          padding: "14px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          boxShadow: "0 -4px 20px rgba(0,0,0,0.4)",
        }}
      >
        <div>
          <div style={{ fontFamily: FONT_HEADING, fontSize: 16, color: C.white, letterSpacing: "0.05em" }}>Google Ads Potenzialcheck</div>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.7)", fontFamily: FONT_BODY }}>297 € einmalig · anrechenbar</div>
        </div>
        <a
          href="#potenzialanalyse"
          style={{
            backgroundColor: C.white,
            color: C.bordeaux,
            padding: "10px 18px",
            fontFamily: FONT_HEADING,
            fontSize: 14,
            letterSpacing: "0.1em",
            textDecoration: "none",
            textTransform: "uppercase",
            flexShrink: 0,
          }}
        >
          Jetzt buchen
        </a>
      </div>

      {/* ══════════════════════════════════════════════════════
          HERO – exakt wie Startseite (HERO_IMG roter Trenchcoat)
      ══════════════════════════════════════════════════════ */}
      <section style={{ backgroundColor: C.black, overflow: "hidden" }} aria-label="Google Ads Betreuung – WERBEAGENTUR Larissa Girenko">

        {/* ── MOBILE: Bild rechts 40%, Text links – identisch zur Startseite ── */}
        <div className="md:hidden bg-black relative" style={{ minHeight: "100svh" }}>
          {/* Bordeaux-Linie oben */}
          <div className="absolute top-0 left-0 right-0" style={{ height: 2, backgroundColor: C.bordeaux, zIndex: 10 }} />

          {/* Bild-Streifen rechts (40%) */}
          <div className="absolute top-0 right-0 bottom-0" style={{ width: "40%" }}>
            <img
              src={HERO_IMG}
              alt="Larissa Girenko"
              className="w-full h-full object-cover"
              style={{ objectPosition: "55% 18%" }}
            />
            <div className="absolute inset-0" style={{ background: "linear-gradient(to right, rgba(0,0,0,1) 0%, rgba(0,0,0,0.55) 35%, rgba(0,0,0,0.1) 100%)" }} />
          </div>

          {/* Text-Bereich */}
          <div className="relative flex flex-col px-6 pt-8 pb-8 gap-5" style={{ zIndex: 10, minHeight: "100svh", maxWidth: "65%" }}>
            {/* Eyebrow */}
            <p style={{ fontFamily: FONT_HEADING, fontSize: 11, letterSpacing: "0.2em", color: C.bordeaux, textTransform: "uppercase", lineHeight: 1.4 }}>
              Google Ads Betreuung · WERBEAGENTUR Larissa Girenko
            </p>

            {/* Scarcity */}
            <SlotsCounter />

            {/* Headline */}
            <h1 style={{ fontFamily: FONT_HEADING, lineHeight: 0.95, color: C.white, margin: 0 }}>
              <span style={{ fontSize: "clamp(2.6rem, 11vw, 3.6rem)", display: "block" }}>GOOGLE</span>
              <span style={{ fontSize: "clamp(2.6rem, 11vw, 3.6rem)", display: "block" }}>ADS, DIE</span>
              <span style={{ fontSize: "clamp(2.6rem, 11vw, 3.6rem)", display: "block", color: C.bordeaux }}>WIRKLICH</span>
              <span style={{ fontSize: "clamp(2.6rem, 11vw, 3.6rem)", display: "block" }}>KUNDEN</span>
              <span style={{ fontSize: "clamp(2.6rem, 11vw, 3.6rem)", display: "block" }}>BRINGEN.</span>
            </h1>

            {/* Subtext */}
            <p style={{ fontSize: "0.82rem", color: "#d1d5db", lineHeight: 1.65, fontFamily: FONT_BODY }}>
              Kein verschwendetes Budget. Keine Blackbox.{" "}
              <strong style={{ color: C.white }}>Persönliche Google Ads Betreuung für KMU.</strong>
            </p>

            {/* CTA */}
            <a
              href={MEETERGO_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{ backgroundColor: C.bordeaux, color: C.white, padding: "14px 20px", fontFamily: FONT_HEADING, fontSize: 16, letterSpacing: "0.12em", textDecoration: "none", display: "block", textAlign: "center", textTransform: "uppercase" }}
            >
              Google Ads Potenzialcheck buchen →
            </a>
            <a
              href="#pakete"
              style={{ border: `2px solid ${C.bordeaux}`, color: C.offWhite, padding: "12px 20px", fontFamily: FONT_HEADING, fontSize: 15, letterSpacing: "0.12em", textDecoration: "none", display: "block", textAlign: "center", textTransform: "uppercase" }}
            >
              Pakete ansehen
            </a>

            {/* Zahlen */}
            <div style={{ display: "flex", gap: 20, flexWrap: "wrap", paddingTop: 16, borderTop: `1px solid ${C.borderLight}` }}>
              {[
                { zahl: "6+", label: "Jahre" },
                { zahl: "50+", label: "Accounts" },
                { zahl: "∅ 3,2×", label: "ROAS" },
              ].map((s) => (
                <div key={s.label}>
                  <div style={{ fontFamily: FONT_HEADING, fontSize: 26, color: C.bordeaux, lineHeight: 1 }}>{s.zahl}</div>
                  <div style={{ fontSize: 10, color: C.muted, textTransform: "uppercase", letterSpacing: "0.1em", marginTop: 2 }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── DESKTOP: Split-Layout – Text links, Bild rechts 44% ── */}
        <div className="hidden md:flex" style={{ maxWidth: 1280, margin: "0 auto", minHeight: 620, alignItems: "stretch" }}>
          {/* Text */}
          <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", padding: "60px 56px" }}>
            <p style={{ fontFamily: FONT_HEADING, fontSize: 13, letterSpacing: "0.22em", color: C.bordeaux, textTransform: "uppercase", marginBottom: 20 }}>
              Google Ads Betreuung · WERBEAGENTUR Larissa Girenko
            </p>

            <div className="ga-hero-animate" style={{ marginBottom: 24 }}>
              <SlotsCounter />
            </div>

            <h1 className="ga-hero-animate-2" style={{ fontFamily: FONT_HEADING, fontSize: "clamp(44px, 5.5vw, 76px)", lineHeight: 1.0, color: C.white, marginBottom: 24, letterSpacing: "0.02em" }}>
              GOOGLE ADS,<br />
              DIE <span style={{ color: C.bordeaux }}>WIRKLICH</span><br />
              KUNDEN BRINGEN.
            </h1>

            <p className="ga-hero-animate-3" style={{ fontSize: 17, color: C.offWhite, maxWidth: 500, lineHeight: 1.75, marginBottom: 32, fontFamily: "'DM Sans', sans-serif" }}>
              Kein verschwendetes Budget. Keine Blackbox.{" "}
              <strong style={{ color: C.white }}>Persönliche Google Ads Betreuung für KMU – von Strategie bis Auswertung.</strong>
            </p>

            <div className="ga-hero-animate-3" style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 40 }}>
              <a
                href={MEETERGO_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="ga-cta-btn"
                style={{ backgroundColor: C.bordeaux, color: C.white, padding: "15px 36px", fontFamily: FONT_HEADING, fontSize: 19, letterSpacing: "0.12em", textDecoration: "none", display: "inline-block", textTransform: "uppercase" }}
              >
                Google Ads Potenzialcheck buchen →
              </a>
              <a
                href="#pakete"
                className="ga-outline-btn"
                style={{ border: `2px solid ${C.bordeaux}`, color: C.offWhite, padding: "15px 36px", fontFamily: FONT_HEADING, fontSize: 19, letterSpacing: "0.12em", textDecoration: "none", display: "inline-block", textTransform: "uppercase" }}
              >
                Pakete ansehen
              </a>
            </div>

            <div className="ga-hero-animate-3" style={{ display: "flex", gap: 36, flexWrap: "wrap", paddingTop: 24, borderTop: `1px solid ${C.borderLight}` }}>
              {[
                { zahl: "6+", label: "Jahre Erfahrung" },
                { zahl: "50+", label: "betreute Accounts" },
                { zahl: "∅ 3,2×", label: "ROAS-Steigerung" },
                { zahl: "−37%", label: "Budget-Verschwendung" },
              ].map((s) => (
                <div key={s.label}>
                  <div style={{ fontFamily: FONT_HEADING, fontSize: 32, color: C.bordeaux, lineHeight: 1 }}>{s.zahl}</div>
                  <div style={{ fontSize: 11, color: C.muted, textTransform: "uppercase", letterSpacing: "0.12em", marginTop: 4 }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Bild rechts – 44% Breite, volle Höhe */}
          <div style={{ width: "44%", position: "relative", overflow: "hidden", flexShrink: 0 }}>
            <img
              src={HERO_IMG}
              alt="Larissa Girenko – Google Ads Expertin"
              style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top center", display: "block" }}
            />
            {/* Gradient links für weichen Übergang */}
            <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to right, rgba(0,0,0,0.35) 0%, transparent 50%)" }} />
            {/* Bordeaux-Linie oben */}
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, backgroundColor: C.bordeaux }} />
          </div>
        </div>

        {/* Bordeaux-Trennlinie unten */}
        <div style={{ height: 3, backgroundColor: C.bordeaux }} />
      </section>

      {/* ══════════════════════════════════════════════════════
          SOCIAL PROOF – hell (weiß) – Google-Bewertung + Trust-Signale mit CI-Icons
      ══════════════════════════════════════════════════════ */}
      <section style={{ backgroundColor: C.lightBg, padding: "56px 24px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          {/* Trust-Badges mit CI-Icons */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 24, marginBottom: 48 }}>
            {[
              { icon: "/manus-storage/47_7e4350f7.svg", text: "Persönliche Betreuung", sub: "Direkt durch Larissa" },
              { icon: "/manus-storage/32_04885248.svg", text: "Voller Account-Zugang", sub: "Du behältst die Kontrolle" },
              { icon: "/manus-storage/18_7df0ad86.svg", text: "Monatlich kündbar", sub: "Keine langen Bindungen" },
              { icon: "/manus-storage/33_d51b7819.svg", text: "Start in 5 Werktagen", sub: "Schnell & unkompliziert" },
            ].map((b) => (
              <div
                key={b.text}
                style={{
                  backgroundColor: C.lightCard,
                  border: `1px solid ${C.lightBorder}`,
                  borderTop: `3px solid ${C.bordeaux}`,
                  padding: "24px 20px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: 10,
                }}
              >
                <img src={b.icon} alt="" style={{ width: 32, height: 32, objectFit: "contain", opacity: 0.85 }} />
                <div>
                  <div style={{ fontFamily: FONT_HEADING, fontSize: 17, color: C.textDark, letterSpacing: "0.04em" }}>{b.text}</div>
                  <div style={{ fontSize: 13, color: C.textMid, marginTop: 2, fontFamily: FONT_BODY }}>{b.sub}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Google-Bewertung */}
          <div style={{ backgroundColor: C.lightCard, border: `1px solid ${C.lightBorder}`, padding: "28px 32px", maxWidth: 700, margin: "0 auto", borderLeft: `4px solid ${C.bordeaux}` }}>
            <div style={{ display: "flex", gap: 3, marginBottom: 10 }}>
              {[...Array(5)].map((_, i) => (
                <span key={i} style={{ color: "#f59e0b", fontSize: 20 }}>★</span>
              ))}
            </div>
            <p style={{ fontFamily: FONT_BODY, fontSize: 16, color: C.textDark, lineHeight: 1.65, fontStyle: "italic", marginBottom: 12 }}>
              „Larissa hat unsere Google Ads Kampagnen komplett neu aufgebaut. Endlich wissen wir, was unser Budget wirklich bringt – und die Ergebnisse sprechen für sich. – SEO, GEO und Datenschutz auf einen Blick. Sehr professionell und schnell!"
            </p>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
              <p style={{ fontSize: 13, color: C.textMid, fontFamily: FONT_BODY, margin: 0 }}>
                <strong style={{ color: C.textDark }}>Lysann Neu</strong> · Google-Bewertung ★★★★★
              </p>
              <a
                href="https://g.page/r/CQwerbeagentur-larissa-girenko/review"
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: 12, color: C.bordeaux, textDecoration: "none", fontFamily: FONT_BODY, borderBottom: `1px solid ${C.bordeaux}`, paddingBottom: 1 }}
              >
                ★★★★★ 5,0 · 5 Google-Bewertungen ansehen →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════
          PROBLEM-SECTION – Loss Aversion (dunkel)
      ══════════════════════════════════════════════════════ */}
      <section style={{ backgroundColor: C.black, padding: "80px 24px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          {/* Responsive: auf Mobile einspaltig, ab 768px zweispaltig */}
          <div className="problem-grid">
            <div>
              <p style={{ fontFamily: FONT_HEADING, fontSize: 13, letterSpacing: "0.22em", color: C.bordeaux, textTransform: "uppercase", marginBottom: 16 }}>
                Das Problem
              </p>
              <h2 style={{ fontFamily: FONT_HEADING, fontSize: "clamp(32px, 4vw, 52px)", lineHeight: 1.05, marginBottom: 24, color: C.white }}>
                JEDEN TAG OHNE<br />
                OPTIMIERUNG<br />
                <span style={{ color: C.bordeaux }}>VERLIERST DU GELD.</span>
              </h2>
              <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                {[
                  "Falsche Keywords fressen dein Budget – ohne eine einzige Anfrage zu bringen",
                  "Anzeigentexte ohne Psychologie werden ignoriert – Konkurrenz gewinnt den Klick",
                  "Kein Conversion-Tracking = du weißt nicht, was wirklich funktioniert",
                  "Große Agenturen kennen dein Business nicht – du bist nur eine Kundennummer",
                ].map((prob, i) => (
                  <div key={i} style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
                    <span style={{ color: C.bordeaux, fontSize: 18, flexShrink: 0, marginTop: 1, fontWeight: 700 }}>✗</span>
                    <p style={{ fontSize: 15, color: C.offWhite, lineHeight: 1.6, margin: 0 }}>{prob}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Loss Calculator */}
            <LossCalculator />
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════
          LÖSUNG – hell (weiß) – Was ich übernehme, mit CI-Icons
      ══════════════════════════════════════════════════════ */}
      <section style={{ backgroundColor: C.lightBg, padding: "96px 24px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 56 }}>
            <p style={{ fontFamily: FONT_HEADING, fontSize: 13, letterSpacing: "0.22em", color: C.bordeaux, textTransform: "uppercase", marginBottom: 12 }}>
              Die Lösung
            </p>
            <h2 style={{ fontFamily: FONT_HEADING, fontSize: "clamp(32px, 4vw, 52px)", color: C.textDark, lineHeight: 1.05 }}>
              VOLLSTÄNDIGE BETREUUNG –<br />
              <span style={{ color: C.bordeaux }}>VON A BIS Z.</span>
            </h2>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 20 }}>
            {[
              { icon: "/manus-storage/23_1ab7147e.svg", nr: "01", titel: "Strategie & Kampagnen-Setup", text: "Ich analysiere dein Angebot, deine Zielgruppe und den Wettbewerb – und baue eine Kampagnenstruktur auf, die von Anfang an konvertiert. Kein Copy-Paste, sondern maßgeschneidert." },
              { icon: "/manus-storage/11_094992a3.svg", nr: "02", titel: "Keyword-Recherche & Anzeigentexte", text: "Tiefgehende Keyword-Analyse mit Fokus auf Suchintention. Anzeigentexte, die nicht nur geklickt werden – sondern die richtigen Besucher anziehen." },
              { icon: "/manus-storage/18_7df0ad86.svg", nr: "03", titel: "Laufende Optimierung", text: "Wöchentliche Auswertung von Klicks, Kosten und Conversions. Gebote, Anzeigen und Zielgruppen werden kontinuierlich angepasst – damit dein Budget nicht verbrennt." },
              { icon: "/manus-storage/32_04885248.svg", nr: "04", titel: "Conversion-Tracking & Reporting", text: "Sauberes Tracking von Anfragen, Käufen und Anrufen. Monatliches Reporting in klarer Sprache – kein Fachjargon, sondern: was hat funktioniert, was nicht, was als nächstes." },
              { icon: "/manus-storage/33_d51b7819.svg", nr: "05", titel: "Qualitätsscore-Optimierung", text: "Schlechte Qualitätsscores kosten bares Geld. Ich optimiere Anzeigen, Landingpages und Keyword-Relevanz – damit du weniger pro Klick zahlst." },
              { icon: "/manus-storage/47_7e4350f7.svg", nr: "06", titel: "Persönliche Betreuung", text: "Du hast eine feste Ansprechpartnerin. Keine Ticketsysteme, kein Callcenter. Direkte Kommunikation – per WhatsApp, E-Mail oder Videocall." },
            ].map((l) => (
              <div key={l.nr} style={{ backgroundColor: C.lightCard, padding: "32px 28px", borderTop: `3px solid ${C.bordeaux}`, border: `1px solid ${C.lightBorder}`, borderTopWidth: 3, borderTopColor: C.bordeaux }}>
                <img src={l.icon} alt="" style={{ width: 36, height: 36, objectFit: "contain", opacity: 0.85, marginBottom: 16 }} />
                <h3 style={{ fontFamily: FONT_HEADING, fontSize: 22, color: C.textDark, marginBottom: 10, letterSpacing: "0.03em" }}>{l.titel}</h3>
                <p style={{ fontSize: 14, color: C.textMid, lineHeight: 1.75 }}>{l.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* ══════════════════════════════════════════════════════
          CASE STUDY – Ergebnis-Beispiel (dunkel)
      ══════════════════════════════════════════════════════ */}
      <section style={{ backgroundColor: C.black, padding: "80px 24px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 48 }}>
            <p style={{ fontFamily: FONT_HEADING, fontSize: 13, letterSpacing: "0.22em", color: C.bordeaux, textTransform: "uppercase", marginBottom: 12 }}>Ergebnis-Beispiel</p>
            <h2 style={{ fontFamily: FONT_HEADING, fontSize: "clamp(28px, 4vw, 48px)", color: C.white, lineHeight: 1.05 }}>
              WAS PROFESSIONELLE BETREUUNG<br />
              <span style={{ color: C.bordeaux }}>KONKRET BEWIRKT.</span>
            </h2>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 24 }}>
            {[
              { vorher: "2,1×", nachher: "3,8×", label: "ROAS", beschreibung: "Dienstleister (Handwerk), 3 Monate – Keyword-Bereinigung und Anzeigentext-Optimierung" },
              { vorher: "37 %", nachher: "12 %", label: "Budget-Verschwendung", beschreibung: "E-Commerce, 6 Wochen – Negative Keywords und Match-Type-Optimierung" },
              { vorher: "4,80 €", nachher: "2,10 €", label: "Cost-per-Click", beschreibung: "Lokales Unternehmen, 4 Wochen – Qualitätsscore von 4 auf 8 verbessert" },
            ].map((s, i) => (
              <div key={i} style={{ backgroundColor: C.cardBg, border: `1px solid ${C.borderLight}`, padding: "32px 28px", borderTop: `3px solid ${C.bordeaux}` }}>
                <div style={{ display: "flex", gap: 24, alignItems: "center", marginBottom: 16 }}>
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontFamily: FONT_HEADING, fontSize: 13, color: C.muted, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 4 }}>Vorher</div>
                    <div style={{ fontFamily: FONT_HEADING, fontSize: 36, color: C.muted, lineHeight: 1 }}>{s.vorher}</div>
                  </div>
                  <div style={{ fontFamily: FONT_HEADING, fontSize: 28, color: C.bordeaux }}>→</div>
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontFamily: FONT_HEADING, fontSize: 13, color: C.bordeaux, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 4 }}>Nachher</div>
                    <div style={{ fontFamily: FONT_HEADING, fontSize: 36, color: C.white, lineHeight: 1 }}>{s.nachher}</div>
                  </div>
                </div>
                <div style={{ fontFamily: FONT_HEADING, fontSize: 18, color: C.offWhite, letterSpacing: "0.05em", marginBottom: 8 }}>{s.label}</div>
                <p style={{ fontSize: 13, color: C.muted, lineHeight: 1.6, margin: 0 }}>{s.beschreibung}</p>
              </div>
            ))}
          </div>
          <p style={{ textAlign: "center", fontSize: 12, color: C.mutedDark, marginTop: 24 }}>Repräsentative Ergebniswerte aus betreuten Accounts. Individuelle Ergebnisse können abweichen.</p>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════
          POTENZIALANALYSE – Einstiegsprodukt (hell)
      ══════════════════════════════════════════════════════ */}
      <section id="potenzialanalyse" style={{ backgroundColor: C.lightBg, padding: "96px 24px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>

          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: 56 }}>
            <p style={{ fontFamily: FONT_HEADING, fontSize: 13, letterSpacing: "0.22em", color: C.bordeaux, textTransform: "uppercase", marginBottom: 12 }}>
              Dein Einstieg
            </p>
            <h2 style={{ fontFamily: FONT_HEADING, fontSize: "clamp(32px, 4.5vw, 58px)", color: C.textDark, lineHeight: 1.05, marginBottom: 16 }}>
              GOOGLE ADS<br />
              <span style={{ color: C.bordeaux }}>POTENZIALANALYSE™</span>
            </h2>
            <p style={{ fontSize: 16, color: C.textMid, maxWidth: 640, margin: "0 auto", lineHeight: 1.75 }}>
              Bevor du einen Euro in Werbung investierst – oder weiter Budget verbrennst – weißt du genau, wo du stehst und was möglich ist.
            </p>
          </div>

          {/* Produkt-Card */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 0, maxWidth: 900, margin: "0 auto" }}>
            <div style={{ backgroundColor: C.white, border: `2px solid ${C.bordeaux}`, padding: "48px 40px", position: "relative" }}>

              {/* Badge */}
              <div style={{ position: "absolute", top: -16, left: 40, backgroundColor: C.bordeaux, color: C.white, fontFamily: FONT_HEADING, fontSize: 13, letterSpacing: "0.18em", padding: "6px 20px", textTransform: "uppercase" }}>
                EINMALIGES EINSTIEGSPRODUKT
              </div>

              <div className="analyse-card-inner">
                <div className="analyse-card-content" style={{ padding: "0 0 32px 0" }}>
                  <h3 style={{ fontFamily: FONT_HEADING, fontSize: 32, color: C.textDark, marginBottom: 8, letterSpacing: "0.03em" }}>
                    GOOGLE ADS POTENZIALANALYSE
                  </h3>
                  <p style={{ fontSize: 14, color: C.textMid, lineHeight: 1.75, marginBottom: 28, maxWidth: 520 }}>
                    Ich analysiere deinen bestehenden Account oder – wenn du noch keinen hast – das Marktpotenzial für dein Business. Das Ergebnis: ein konkreter Fahrplan, was funktioniert, was nicht und was als nächstes zu tun ist.
                  </p>

                  {/* 12 Analyse-Faktoren */}
                  <p style={{ fontFamily: FONT_HEADING, fontSize: 14, letterSpacing: "0.15em", color: C.bordeaux, textTransform: "uppercase", marginBottom: 16 }}>
                    12 Analyse-Faktoren
                  </p>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "10px 24px", marginBottom: 32 }}>
                    {[
                      { nr: "01", label: "Kampagnenstruktur & Aufbau" },
                      { nr: "02", label: "Keyword-Strategie & Match-Types" },
                      { nr: "03", label: "Negative Keywords & Streuverlust" },
                      { nr: "04", label: "Anzeigentexte & Qualitätsscore" },
                      { nr: "05", label: "Gebotsstrategien & Budget-Verteilung" },
                      { nr: "06", label: "Conversion-Tracking & Ziele" },
                      { nr: "07", label: "Zielgruppen & Remarketing" },
                      { nr: "08", label: "Landingpage-Relevanz & UX" },
                      { nr: "09", label: "Wettbewerbs-Analyse & Marktpotenzial" },
                      { nr: "10", label: "Suchterm-Berichte & Optimierungspotenzial" },
                      { nr: "11", label: "Erweiterungen & Assets" },
                      { nr: "12", label: "ROAS / CPA & Wirtschaftlichkeit" },
                    ].map((f) => (
                      <div key={f.nr} style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
                        <span style={{ fontFamily: FONT_HEADING, fontSize: 13, color: C.bordeaux, flexShrink: 0, minWidth: 24 }}>{f.nr}</span>
                        <span style={{ fontSize: 13, color: C.textDark, lineHeight: 1.5 }}>{f.label}</span>
                      </div>
                    ))}
                  </div>

                  {/* Lieferumfang */}
                  <p style={{ fontFamily: FONT_HEADING, fontSize: 14, letterSpacing: "0.15em", color: C.bordeaux, textTransform: "uppercase", marginBottom: 12 }}>
                    Was du bekommst
                  </p>
                  <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 32 }}>
                    {[
                      "Schriftlicher Report mit allen 12 Faktoren und konkreten Handlungsempfehlungen",
                      "60-minütiger Video-Call zur Besprechung der Ergebnisse und nächsten Schritte",
                      "Priorisierte Maßnahmen-Liste: Was bringt am meisten, was sofort umsetzen?",
                      "Vollständige Anrechnung auf laufende Betreuung bei Buchung innerhalb von 30 Tagen",
                    ].map((item, i) => (
                      <div key={i} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                        <span style={{ color: C.bordeaux, fontWeight: 700, flexShrink: 0, marginTop: 1 }}>✓</span>
                        <span style={{ fontSize: 14, color: C.textDark, lineHeight: 1.6 }}>{item}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Preis-Box */}
                <div className="analyse-preis-box" style={{ textAlign: "center", padding: "32px 28px", backgroundColor: C.black }}>
                  <p style={{ fontFamily: FONT_HEADING, fontSize: 12, letterSpacing: "0.18em", color: C.muted, textTransform: "uppercase", marginBottom: 8 }}>Einmalig</p>
                  <div style={{ fontFamily: FONT_HEADING, fontSize: 64, color: C.white, lineHeight: 1 }}>297 €</div>
                  <p style={{ fontSize: 11, color: C.muted, marginTop: 6, marginBottom: 24, lineHeight: 1.5 }}>zzgl. MwSt.<br />Lieferung in 5–7 Werktagen</p>
                    <CheckoutButton
                    productId="google_ads_potenzialanalyse"
                    label="Jetzt buchen →"
                    price="297 €"
                    returnPath="/google-ads"
                    fullWidth
                  />
                  <p style={{ fontSize: 11, color: C.muted, marginTop: 10, lineHeight: 1.5 }}>Wird bei Betreuungs-Buchung<br />vollständig angerechnet</p>
                  <p style={{ fontSize: 10, color: C.muted, marginTop: 8, lineHeight: 1.5 }}>Zahlung über Stripe (SSL-verschlüsselt). Kauf auf Rechnung möglich. Kein Abo.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Ideal für */}
          <div style={{ textAlign: "center", marginTop: 40 }}>
            <p style={{ fontSize: 13, color: C.textMid }}>
              <strong style={{ color: C.textDark }}>Ideal für:</strong> Selbstständige, kleine & mittlere Unternehmen – ob mit bestehendem Account oder komplett neu bei Google Ads.
            </p>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════
          PAKETE – dunkel (schwarz) – Anchoring + Highlighting
      ══════════════════════════════════════════════════════ */}
      <section id="pakete" style={{ backgroundColor: C.black, padding: "96px 24px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 16 }}>
            <p
              style={{
                fontFamily: FONT_HEADING,
                fontSize: 13,
                letterSpacing: "0.22em",
                color: C.bordeaux,
                textTransform: "uppercase",
                marginBottom: 12,
              }}
            >
              Pakete & Preise
            </p>
            <h2
              style={{
                fontFamily: FONT_HEADING,
                fontSize: "clamp(32px, 4vw, 52px)",
                color: C.white,
                lineHeight: 1.05,
                marginBottom: 12,
              }}
            >
              TRANSPARENTE PREISE.<br />
              <span style={{ color: C.bordeaux }}>KEINE VERSTECKTEN KOSTEN.</span>
            </h2>
            <p style={{ fontSize: 14, color: C.muted, marginBottom: 8 }}>
              Das Werbebudget bei Google ist <strong style={{ color: C.white }}>separat</strong> und wird direkt an Google gezahlt – nicht an mich.
            </p>
            {/* Anchoring-Subline */}
            <p style={{ fontSize: 13, color: "rgba(255,255,255,0.45)", marginBottom: 16, fontStyle: "italic" }}>
              Die meisten Kunden wählen PROFESSIONAL – weil es das beste Preis-Leistungs-Verhältnis bietet.
            </p>
            {/* Scarcity */}
            <p
              style={{
              fontSize: 13,
              color: C.offWhite,
              fontFamily: FONT_BODY,
              marginBottom: 48,
              }}
            >
              ⚠ Aktuell nehme ich nur 2 neue Kunden im {currentMonth} an – für maximale Betreuungsqualität.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: 2,
            }}
          >
            {PAKETE.map((p) => (
              <div
                key={p.name}
                className="ga-paket-card"
                style={{
                  backgroundColor: p.highlight ? C.bordeaux : C.cardBg,
                  padding: "40px 32px",
                  position: "relative",
                  border: p.highlight ? "none" : `1px solid ${C.borderLight}`,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {p.tag && (
                  <div
                    style={{
                      position: "absolute",
                      top: -14,
                      left: "50%",
                      transform: "translateX(-50%)",
                      backgroundColor: p.highlight ? C.white : C.bordeaux,
                      color: p.highlight ? C.bordeaux : C.white,
                      fontSize: 11,
                      fontWeight: 700,
                      letterSpacing: "0.18em",
                      textTransform: "uppercase",
                      padding: "5px 16px",
                      whiteSpace: "nowrap",
                      fontFamily: FONT_HEADING,
                    }}
                  >
                    {p.tag}
                  </div>
                )}

                <p
                  style={{
                    fontFamily: FONT_HEADING,
                    fontSize: 13,
                    letterSpacing: "0.22em",
                    color: p.highlight ? "rgba(255,255,255,0.7)" : C.bordeaux,
                    textTransform: "uppercase",
                    marginBottom: 10,
                  }}
                >
                  {p.name}
                </p>

                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    gap: 6,
                    marginBottom: 10,
                  }}
                >
                  <span
                    style={{
                      fontFamily: FONT_HEADING,
                      fontSize: 44,
                      color: C.white,
                      lineHeight: 1,
                    }}
                  >
                    {p.preis}
                  </span>
                  {p.zeitraum && (
                    <span
                      style={{
                        color: p.highlight ? "rgba(255,255,255,0.6)" : C.muted,
                        fontSize: 15,
                      }}
                    >
                      {p.zeitraum}
                    </span>
                  )}
                </div>

                <p
                  style={{
                    fontSize: 13,
                    color: p.highlight ? "rgba(255,255,255,0.8)" : C.muted,
                    lineHeight: 1.6,
                    marginBottom: p.perTagNote ? 8 : 24,
                  }}
                >
                  {p.beschreibung}
                </p>
                {p.perTagNote && (
                  <p style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", marginBottom: 8, fontFamily: FONT_HEADING, letterSpacing: "0.08em" }}>
                    {p.perTagNote}
                  </p>
                )}
                {p.savingsNote && (
                  <p style={{ fontSize: 12, color: "rgba(255,255,255,0.7)", marginBottom: 24, fontStyle: "italic" }}>
                    💡 {p.savingsNote}
                  </p>
                )}
                {!p.savingsNote && !p.perTagNote && <div style={{ marginBottom: 0 }} />}

                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    margin: "0 0 32px",
                    display: "flex",
                    flexDirection: "column",
                    gap: 10,
                    flex: 1,
                  }}
                >
                  {p.leistungen.map((l) => (
                    <li
                      key={l}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 10,
                        fontSize: 14,
                        color: p.highlight ? C.white : C.offWhite,
                      }}
                    >
                      <span
                        style={{
                          color: p.highlight ? C.white : C.bordeaux,
                          flexShrink: 0,
                          marginTop: 2,
                          fontWeight: 700,
                        }}
                      >
                        ✓
                      </span>
                      {l}
                    </li>
                  ))}
                </ul>

                <a
                  href="#potenzialanalyse"
                  style={{
                    display: "block",
                    textAlign: "center",
                    padding: "14px 24px",
                    backgroundColor: p.highlight ? C.white : C.bordeaux,
                    color: p.highlight ? C.bordeaux : C.white,
                    fontFamily: FONT_HEADING,
                    fontSize: 17,
                    letterSpacing: "0.12em",
                    textDecoration: "none",
                    textTransform: "uppercase",
                  }}
                >
                  {p.cta} →
                </a>
                <p style={{ fontSize: 11, color: p.highlight ? "rgba(255,255,255,0.6)" : C.muted, textAlign: "center", marginTop: 8, fontFamily: FONT_BODY }}>Starte mit der Potenzialanalyse (297 €)</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════
          PROZESS – hell (weiß) – 4 Schritte mit CI-Icons
      ══════════════════════════════════════════════════════ */}
      <section style={{ backgroundColor: C.lightBg, padding: "96px 24px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 56 }}>
            <p style={{ fontFamily: FONT_HEADING, fontSize: 13, letterSpacing: "0.22em", color: C.bordeaux, textTransform: "uppercase", marginBottom: 12 }}>
              So läuft es ab
            </p>
            <h2 style={{ fontFamily: FONT_HEADING, fontSize: "clamp(32px, 4vw, 52px)", color: C.textDark, lineHeight: 1.05 }}>
              IN 4 SCHRITTEN ZU<br />
              <span style={{ color: C.bordeaux }}>DEINER ERSTEN KAMPAGNE.</span>
            </h2>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 20 }}>
            {[
              { icon: "/manus-storage/47_7e4350f7.svg", nr: "01", titel: "Potenzialanalyse", text: "Ich analysiere deinen bestehenden Account oder das Marktpotenzial für dein Business. Du erhältst einen schriftlichen Report + Video-Call zur Besprechung.", dauer: "5–7 Werktage" },
              { icon: "/manus-storage/23_1ab7147e.svg", nr: "02", titel: "Strategie & Setup", text: "Keyword-Recherche, Kampagnenstruktur, Anzeigentexte, Tracking. Alles wird vor dem Start mit dir abgestimmt.", dauer: "3–5 Werktage" },
              { icon: "/manus-storage/18_7df0ad86.svg", nr: "03", titel: "Launch & Optimierung", text: "Die Kampagnen gehen live. In den ersten Wochen optimiere ich intensiv – Gebote, Anzeigen, Zielgruppen.", dauer: "Woche 1–4" },
              { icon: "/manus-storage/32_04885248.svg", nr: "04", titel: "Reporting & Wachstum", text: "Monatliches Reporting in klarer Sprache. Wir besprechen Ergebnisse und planen die nächsten Schritte gemeinsam.", dauer: "Monatlich" },
            ].map((s) => (
              <div key={s.nr} style={{ backgroundColor: C.lightCard, padding: "36px 28px", border: `1px solid ${C.lightBorder}`, borderTop: `3px solid ${C.bordeaux}`, position: "relative" }}>
                <img src={s.icon} alt="" style={{ width: 36, height: 36, objectFit: "contain", opacity: 0.85, marginBottom: 16 }} />
                <div style={{ fontFamily: FONT_HEADING, fontSize: 52, color: C.bordeaux, opacity: 0.15, lineHeight: 1, marginBottom: 8 }}>{s.nr}</div>
                <h3 style={{ fontFamily: FONT_HEADING, fontSize: 22, color: C.textDark, marginBottom: 10, letterSpacing: "0.03em" }}>{s.titel}</h3>
                <p style={{ fontSize: 14, color: C.textMid, lineHeight: 1.75, marginBottom: 16 }}>{s.text}</p>
                <span style={{ fontSize: 11, color: C.bordeaux, textTransform: "uppercase", letterSpacing: "0.12em", fontFamily: FONT_HEADING, fontWeight: 700 }}>{s.dauer}</span>
              </div>
            ))}
          </div>

          {/* CTA nach Prozess */}
          <div style={{ textAlign: "center", marginTop: 48 }}>
            <a
              href={MEETERGO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="ga-cta-btn"
              style={{
                backgroundColor: C.bordeaux,
                color: C.white,
                padding: "16px 44px",
                fontFamily: FONT_HEADING,
                fontSize: 20,
                letterSpacing: "0.12em",
                textDecoration: "none",
                display: "inline-block",
                textTransform: "uppercase",
              }}
            >
              Google Ads Potenzialcheck buchen →
            </a>
            <p style={{ fontSize: 12, color: C.muted, marginTop: 12 }}>
              Persönlich von Larissa · Antwort innerhalb von 24h
            </p>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════
          FAQ – hell (weiß)
      ══════════════════════════════════════════════════════ */}
      <section style={{ backgroundColor: C.lightBg, padding: "96px 24px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 48 }}>
            <p style={{ fontFamily: FONT_HEADING, fontSize: 13, letterSpacing: "0.22em", color: C.bordeaux, textTransform: "uppercase", marginBottom: 12 }}>
              Häufige Fragen
            </p>
            <h2 style={{ fontFamily: FONT_HEADING, fontSize: "clamp(28px, 4vw, 48px)", color: C.textDark, lineHeight: 1.05 }}>
              FAQ – GOOGLE ADS BETREUUNG
            </h2>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
            {FAQ_ITEMS.map((item, i) => (
              <div key={i} style={{ borderBottom: `1px solid ${C.lightBorder}` }}>
                <button
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  style={{ width: "100%", textAlign: "left", padding: "22px 0", background: "none", border: "none", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16 }}
                >
                  <span style={{ fontFamily: FONT_BODY, fontWeight: 700, fontSize: 16, color: C.textDark }}>{item.frage}</span>
                  <span style={{ color: C.bordeaux, fontSize: 24, flexShrink: 0, fontWeight: 300, lineHeight: 1 }}>{openFaq === i ? "−" : "+"}</span>
                </button>
                {openFaq === i && (
                  <div style={{ paddingBottom: 22, fontSize: 15, color: C.textMid, lineHeight: 1.75 }}>
                    {item.antwort}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════
          FINAL CTA – Bordeaux-Sektion
      ══════════════════════════════════════════════════════ */}
      <section
        style={{
          backgroundColor: C.bordeaux,
          padding: "80px 24px",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Subtiler Hintergrund-Effekt */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "radial-gradient(ellipse at center, rgba(255,255,255,0.05) 0%, transparent 70%)",
            pointerEvents: "none",
          }}
        />
        <div style={{ maxWidth: 720, margin: "0 auto", position: "relative" }}>
          <p
            style={{
              fontFamily: FONT_HEADING,
              fontSize: 13,
              letterSpacing: "0.22em",
              color: "rgba(255,255,255,0.6)",
              textTransform: "uppercase",
              marginBottom: 16,
            }}
          >
            Bereit für mehr Kunden?
          </p>
          <h2
            style={{
              fontFamily: FONT_HEADING,
              fontSize: "clamp(36px, 5.5vw, 64px)",
              color: C.white,
              lineHeight: 1.0,
              marginBottom: 20,
            }}
          >
            NOCH 2 FREIE PLÄTZE<br />
            IM {currentMonth.toUpperCase()}.
          </h2>
          <p
            style={{
              color: "rgba(255,255,255,0.85)",
              fontSize: 17,
              lineHeight: 1.75,
              marginBottom: 40,
              maxWidth: 560,
              margin: "0 auto 40px",
            }}
          >
            Buche jetzt die Google Ads Potenzialanalyse™ (297 €) – ich analysiere deinen Account oder dein Marktpotenzial nach 12 Faktoren und liefere dir einen konkreten Fahrplan. Bei Buchung einer laufenden Betreuung wird der Betrag vollständig angerechnet.
          </p>
          <a
            href="#potenzialanalyse"
            style={{
              backgroundColor: C.white,
              color: C.bordeaux,
              padding: "18px 48px",
              fontFamily: FONT_HEADING,
              fontSize: 22,
              letterSpacing: "0.12em",
              textDecoration: "none",
              display: "inline-block",
              textTransform: "uppercase",
            }}
          >
            Jetzt Potenzialanalyse™ buchen →
          </a>
          <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 12, marginTop: 10 }}>297 € einmalig · wird bei Betreuungs-Buchung vollständig angerechnet</p>
          <p
            style={{
              color: "rgba(255,255,255,0.55)",
              fontSize: 12,
              marginTop: 18,
              letterSpacing: "0.08em",
            }}
          >
            Persönlich von Larissa ·{" "}
            <a href="https://werbeagentur.me" target="_blank" rel="noopener noreferrer" style={{ color: "rgba(255,255,255,0.55)", textDecoration: "underline" }}>werbeagentur.me</a>
            {" "}· Antwort innerhalb von 24h
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer
        style={{
          backgroundColor: C.darkBg,
          padding: "32px 24px",
          textAlign: "center",
          borderTop: `1px solid ${C.borderLight}`,
        }}
      >
        <p style={{ color: "#444", fontSize: 13 }}>
          © 2026 WERBEAGENTUR Larissa Girenko ·{" "}
          <a href="/impressum" style={{ color: "#555", textDecoration: "none" }}>
            Impressum
          </a>{" "}
          ·{" "}
          <a href="/datenschutz" style={{ color: "#555", textDecoration: "none" }}>
            Datenschutz
          </a>{" "}
          ·{" "}
          <a
            href="https://werbeagentur.me"
            style={{ color: "#555", textDecoration: "none" }}
          >
            werbeagentur.me
          </a>
        </p>
      </footer>
    </div>
  );
}
